module.exports = __webpack_public_path__ + "img/hall-index-banner.da3b4771.png";